// import axiosInstance from "../../apiAxios/axiosInstance";


// export const getDashboardCountList = async () => {
//   const response = await axiosInstance.get("/admin/dashboard-count-list" );
//   return response.data;
// };
import axiosInstance from '../../apiAxios/axiosInstance';
export const PieCharData = async () => {
  const response = await axiosInstance.get("vendor/vendor-piechart-dashboard-count", );
  return response.data;
};
export const getDashboardCountList = async () => {
  const res = await axiosInstance.get(
    "/vendor/vendor-dashboard-count-list"
  );
  return res.data;
};
 
export const getTodayDashboardCountList = async () => {
  const res = await axiosInstance.get(
    "/vendor/vendor-today-dashboard-count-list"
  );
  return res.data;
};





export const getDashboardCounts = async () => {
  const response = await axiosInstance.get("vendor/vendor-dashboard-count-list");
  return response.data;
};

export const getTodayDashboardCounts = async () => {
  const response = await axiosInstance.get("vendor/vendor-today-dashboard-count-list");
  return response.data;
};

export const getPieChartData = async () => {
  const response = await axiosInstance.get("vendor/vendor-piechart-dashboard-count");
  return response.data;
};

export const getActiveModules = async () => {
  const response = await axiosInstance.get("vendor/vendor-all-active-modules-dashboard");
  return response.data;
};
